/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BigCommerceProductRef } from "./BigCommerceProductRef";
import {
  BigCommerceProductRefFromJSON,
  BigCommerceProductRefFromJSONTyped,
  BigCommerceProductRefToJSON,
  BigCommerceProductRefToJSONTyped,
} from "./BigCommerceProductRef";

/**
 *
 * @export
 * @interface BigCommerceProductHandlingTime
 */
export interface BigCommerceProductHandlingTime {
  /**
   *
   * @type {BigCommerceProductRef}
   * @memberof BigCommerceProductHandlingTime
   */
  product: BigCommerceProductRef;
  /**
   *
   * @type {number}
   * @memberof BigCommerceProductHandlingTime
   */
  businessDays: number;
}

/**
 * Check if a given object implements the BigCommerceProductHandlingTime interface.
 */
export function instanceOfBigCommerceProductHandlingTime(
  value: object,
): value is BigCommerceProductHandlingTime {
  if (!("product" in value) || value["product"] === undefined) return false;
  if (!("businessDays" in value) || value["businessDays"] === undefined)
    return false;
  return true;
}

export function BigCommerceProductHandlingTimeFromJSON(
  json: any,
): BigCommerceProductHandlingTime {
  return BigCommerceProductHandlingTimeFromJSONTyped(json, false);
}

export function BigCommerceProductHandlingTimeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceProductHandlingTime {
  if (json == null) {
    return json;
  }
  return {
    product: BigCommerceProductRefFromJSON(json["product"]),
    businessDays: json["businessDays"],
  };
}

export function BigCommerceProductHandlingTimeToJSON(
  json: any,
): BigCommerceProductHandlingTime {
  return BigCommerceProductHandlingTimeToJSONTyped(json, false);
}

export function BigCommerceProductHandlingTimeToJSONTyped(
  value?: BigCommerceProductHandlingTime | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    product: BigCommerceProductRefToJSON(value["product"]),
    businessDays: value["businessDays"],
  };
}
